import React from 'react';
import { useTranslation } from 'SERVICES/i18n';
import './Buttons.scss';
import 'RESOURCES/styles/globalStyles.scss';

import { Button } from '@fluentui/react-northstar';
import HandoverWhite from 'RESOURCES/images/handover-white.svg';
import HandoverGrey from 'RESOURCES/images/handover-grey.svg';
import HandoverWaiting from 'RESOURCES/images/handover-waiting.svg';
import { ENTER_KEY_CODE } from 'CONSTANTS/appConstants';
import {
  showToast,
  TOAST_DURATION,
  TOAST_TYPE,
} from 'FEATURES/interpreter/components/CustomToastContainer';
import { HANDOVER_BUTTON_STATE } from 'FEATURES/interpreter/constants';

const mapStateToIcon = {
  active: { icon: HandoverWhite, bgcolor: 'greenButton' }, // white on green
  request: { icon: HandoverWhite, bgcolor: 'yellowButton' }, // white on yellow
  rest: { icon: HandoverGrey, bgcolor: 'customSecondaryButton' }, // grey on white
  waiting: { icon: HandoverWaiting, bgcolor: 'yellowButton' }, // white menu dots
  disable: { icon: HandoverWhite, bgcolor: 'greyButton' }, // white on grey
};

const HandoverButton = ({ state = 'disable', onClick }) => {
  const { t } = useTranslation('interpreter', { keyPrefix: 'DASHBOARD' });
  return (
    <Button
      onClick={() => {
        if (state === HANDOVER_BUTTON_STATE.disabled) {
          showToast({
            data: {
              content: t('DISABLED_HANDOVER_BUTTON_CLICKED'),
              autoClose: TOAST_DURATION.long,
              type: TOAST_TYPE.error,
            },
          });
          return;
        }
        onClick();
      }}
      onKeyDown={(e) => {
        if (state !== 'disable' && e.keyCode === ENTER_KEY_CODE) onClick();
      }}
      className={`${mapStateToIcon[state].bgcolor} click-effect icon-button-medium imageButton`}
      icon={<img src={mapStateToIcon[state].icon} alt={t('HANDOVER')} />}
      title={t('HANDOVER')}
    />
  );
};

export default HandoverButton;
